import { render, staticRenderFns } from "./SidFontWeight.vue?vue&type=template&id=058836be"
import script from "./SidFontWeight.vue?vue&type=script&lang=js"
export * from "./SidFontWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports